import { initializeApp } from "firebase/app";
import { getAnalytics, Analytics, logEvent } from "firebase/analytics";
import { getPerformance, FirebasePerformance, PerformanceTrace, trace } from "firebase/performance";
import { getLob } from "./services/authenticationService";

// Define the Firebase configuration type
const firebaseConfig = {
  apiKey: "AIzaSyAw0d_nvQ3X2KhQC6Bf_8zmMh-pHL_k2ps",
  authDomain: "salescodecoe-demo.firebaseapp.com",
  projectId: "salescodecoe-demo",
  storageBucket: "salescodecoe-demo.firebasestorage.app",
  messagingSenderId: "206379887853",
  appId: "1:206379887853:web:d12488d181e76f0d83b0e4",
  measurementId: "G-0S1YC2G8RX",
};

// niine demo firebase config (to be removed)
const niineFirebaseConfig = {
  apiKey: "AIzaSyB28AfKDsU1NuL71RDXmXVN5xwkURaj3Cc",
  authDomain: "niinedemo.firebaseapp.com",
  projectId: "niinedemo",
  storageBucket: "niinedemo.firebasestorage.app",
  messagingSenderId: "55293616703",
  appId: "1:55293616703:web:3d1f311044e8949d0a8e8a",
  measurementId: "G-KG9WZ0YN3T"
}

// cavinkare demo firebase config (to be removed)
const cavinKareDemoFirebaseConfig = {
  apiKey: "AIzaSyBieBetOXE-nxZsaKMKk0tBYff4GOaH0K8",
  authDomain: "cavinkare-demo.firebaseapp.com",
  projectId: "cavinkare-demo",
  storageBucket: "cavinkare-demo.firebasestorage.app",
  messagingSenderId: "1031075225511",
  appId: "1:1031075225511:web:a01f8bb7085c4db41c6082",
  measurementId: "G-T96MFH4T4K"
};

const lob = getLob();
const configToUse = lob === "niinedemo" ? niineFirebaseConfig : lob === "ckcoedemo" ? cavinKareDemoFirebaseConfig : firebaseConfig;

// Initialize Firebase
const app = initializeApp(configToUse);

// Initialize Analytics
const analytics: Analytics = getAnalytics(app);

// Initialize Performance Monitoring
const performance: FirebasePerformance = getPerformance(app);

const logLoadTrace = async (functionToTrace:()=>any,name:string)=>{
  const pageLoadTrace: PerformanceTrace = trace(performance, name);
  const t = new Date();
  pageLoadTrace.start();
  try{
    await functionToTrace();
  }catch(e){}
  pageLoadTrace.stop();
  console.log(`${name} log traced: ${(pageLoadTrace as any).durationUs / 1000} ms`);
}

const logAnalyticsEvent = (eventName:string, eventParams:any)=>{
  console.log(`${eventName} log triggered: ${JSON.stringify(eventParams)}`);
  logEvent(analytics, eventName, eventParams);
}

// Export for use in other files
export { analytics, performance, logLoadTrace, logAnalyticsEvent };
